<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button
              @click="createWarehouse()"
              class="bg_l_green"
              v-has-permission="permission104"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewWarehouse") }}
            </vs-button>
          </div>
        </div>
        <modify-popup
          ref="modifyPopup"
          :show="ModifyPopup"
          @finish="onfinish"
          @close="closeModifyPopup"
        ></modify-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('WarehouseName'), sort: 'WarehouseName' },
                { title: $t('AutomationCode'), sort: 'AutomationCode' },
                { title: $t('WarehouseCode'), sort: 'WarehouseCode' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 19%">
                  {{ row.name }}
                </td>
                <td style="width: 19%">
                  {{ row.automationCode }}
                </td>
                <td style="width: 19%">
                  {{ row.code }}
                </td>
                <td style="width: 16%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 21%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="view-btn"
                    @click.prevent="editShelve(row)"
                    v-has-permission="permission107"
                    >{{ $t("Shelves") }}</vs-button
                  >
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.prevent="editWarehouse(row)"
                    class="ml-4 d-inline"
                    v-has-permission="permission106"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteWarehouse(row.id)"
                    class="d-inline"
                    v-has-permission="permission105"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <shelve-popup
          ref="theModal"
          :show="ShelvePopup"
          @finish="shelvePopupFinish"
        ></shelve-popup>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";
import ShelvePopup from "./ShelvePopup.vue";
import { setTimeout } from "timers";

export default {
  name: "warehouseManagement_Warehouses_Index",
  components: {
    ModifyPopup,
    DataGrid,
    ShelvePopup,
  },
  data() {
    return {
      permission104: "CreateWarehouse",
      permission105: "DeleteWarehouse",
      permission106: "ModifyWarehouse",
      permission107: "GetAllWarehouse",
      ModifyPopup: false,
      ShelvePopup: false,
      shelveModel: {},
      shelveInfo: {},
      gridDataSource: {
        type: "app",
        service: "WarehousingManagement/api/WarehouseQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/list",
    }),
  },
  methods: {
    ...mapActions({
      removeWarehouse: "warehouse/remove",
      fetchWarehouses: "warehouse/fetchListWithNOTakeSkip",
    }),
    ////Open Modal In Create Mode
    createWarehouse() {
      var modalModel = {
        warehouseId: null,
        location: {
        },
      };
      this.ModifyPopup = true;
      this.$refs.modifyPopup.load(modalModel);
    },
    //Open Modal In Edit Mode
    editWarehouse(model) {
      var modalModel = {
        warehouseId: model.id,
        name: model.name,
        code: model.code,
        automationCode: model.automationCode,
        location: {
          countryId: model.location.countryId,
          countryName: model.location.countryName,
          provinceId: model.location.provinceId,
          provinceName: model.location.provinceName,
          cityId: model.location.cityId,
          cityName: model.location.cityName,
          address: model.location.address,
          longitude: model.location.longitude,
          latitude: model.location.latitude,
        },
      };
      this.ModifyPopup = true;
      this.$refs.modifyPopup.load(modalModel);
    },
    //////Open shelve Modal
    editShelve(model) {
      this.fetchWarehouses().then(() => {
        this.shelveInfo = this.allWarehouses.filter(
          (x) => x.id == model.id
        )[0].shelveQueries;
        this.ShelvePopup = true;
        this.shelveModel = {
          id: model.id,
          shelveQueries: this.shelveInfo,
        };
        this.$refs.theModal.load(this.shelveModel);
      });
    },
    //Delete Method
    deleteWarehouse(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeWarehouse(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    },
    shelvePopupFinish() {
      this.ShelvePopup = false;
    },
  },
};
</script>
